var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.96175 3.48273C8.96175 1.92099 11.6497 2.72201 11.6497 2.72201L12 0.296712C12 0.296712 10.6188 -0.0626631 8.96175 0.00960113C5.54979 0.156909 5.6678 2.88683 5.6678 2.88683V5.27127H4V7.7377H5.6678V16H8.96175V7.7377H11.4646L11.657 5.27127H8.96175V3.48273Z", fill: "#9B9B9B" })
  );
});